import {Fade} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Typography from '@material-ui/core/Typography';
import {Alert} from '@material-ui/lab';
import AlertTitle from '@material-ui/lab/AlertTitle';
import {useRefreshSpinnerStyles} from 'Core/components/RefreshSpinner';
import {isForceLogout} from 'Core/ducks/login';
import {logoutISAM} from 'Core/ducks/refreshToken';
import {useInactivityTimer} from 'Shared/components/InactivityTracker/useInactivityTimer';
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';

type InactivityTrackerProps = {
  inactivityWarningTime: number;
  logoutTimeAfterWarning: number;
};

const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const secondsMessage = `${remainingSeconds < 10 ? '0' : ''}${remainingSeconds} seconds`;
  return minutes > 0 ? `${minutes} minutes and ${secondsMessage}` : `${secondsMessage}`;
};

export const InactivityTracker = ({inactivityWarningTime, logoutTimeAfterWarning}: InactivityTrackerProps) => {
  const classes = useRefreshSpinnerStyles();

  const dispatch = useDispatch();

  const onLogout = useCallback(() => {
    dispatch(isForceLogout(true));
    dispatch(logoutISAM());
  }, []);

  const {showWarning, countdown} = useInactivityTimer(onLogout, inactivityWarningTime, logoutTimeAfterWarning);

  return (
    <Backdrop style={{zIndex: 10000}} open={showWarning} transitionDuration={100} className={classes.backdrop}>
      <Fade in={showWarning} timeout={100} mountOnEnter unmountOnExit>
        <Alert severity="warning">
          <AlertTitle style={{fontSize: '1rem', fontWeight: 600}}>Are you still there?</AlertTitle>
          <Typography>
            You will be logged out due to inactivity in <strong>{formatTime(countdown)}.</strong>
          </Typography>
        </Alert>
      </Fade>
    </Backdrop>
  );
};
